import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import styled from 'styled-components'
import vars from 'li-components/lib/styles'
import TargetBlank from 'li-components/lib/TargetBlank'

import { getAppDotOrigin, track } from '../util'
import RegisterLink from './RegisterLink'

const Footer = styled.footer`
  color: ${vars.grayLight};

  p:nth-of-type(1),
  p:nth-of-type(3) {
    margin: 1.75rem 0;
    color: ${vars.textColor};
  }

  p:nth-of-type(3) {
    line-height: 2rem;
  }

  a {
    text-decoration: none;
    color: ${vars.brandPrimary};

    &:hover {
      text-decoration: underline;
    }
  }
`

const LoginFooter = (props, { useRelativePasswordResetLink }) => (
  <Footer>
    <small>
      By registering or signing in you agree to our&nbsp;
      <TargetBlank
        href="https://public-assets.labelinsight.com/labelinsight/Label_Insight_eula.pdf"
        onClick={() => {
          track({ event: 'loginFormLinkClick', label: 'eula' })
        }}
      >
        End User License Agreement (EULA)
      </TargetBlank>{' '}
      and&nbsp;
      <TargetBlank
        href="https://public-assets.labelinsight.com/labelinsight/Privacy_Policy-Label_Insight_Inc.pdf"
        onClick={() => {
          track({ event: 'loginFormLinkClick', label: 'privacyPolicy' })
        }}
      >
        Privacy Policy
      </TargetBlank>.
    </small>
    <p>
      Don’t have an account?{' '}
      <RegisterLink
        onClick={() => {
          track({ event: 'loginFormLinkClick', label: 'register' })
        }}
      >
        Register now
      </RegisterLink>
    </p>
    <p>
      {useRelativePasswordResetLink ? (
        <Link
          to="/reset-password"
          onClick={() => {
            track({ event: 'loginFormLinkClick', label: 'resetPassword' })
          }}
        >
          I forgot my password
        </Link>
      ) : (
        <a
          href={`${getAppDotOrigin()}/reset-password`}
          onClick={() => {
            track({ event: 'loginFormLinkClick', label: 'resetPassword' })
          }}
        >
          I forgot my password
        </a>
      )}
    </p>
    <p>
      Need help?<br />
      <TargetBlank href="https://helpdesk.labelinsight.com/hc/en-us">
        Submit a support ticket
      </TargetBlank>
    </p>
  </Footer>
)

LoginFooter.contextTypes = {
  useRelativePasswordResetLink: PropTypes.bool.isRequired,
}

export default LoginFooter



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/LoginFooter.js